import initialState from './../../initialState';
export default (state = initialState.problema, { type, value, response }) => {
  switch (type) {
    case 'LIST_MEUS_REGISTROS_PROBLEMA_SUCCESS':
      return {
        ...state,
        meusRegistros: {
          ...state.meusRegistros,
          fetching: 2,
          ...response
        }
      };
    case 'LIST_LOCAIS_PROBLEMA_SUCCESS':
      return {
        ...state,
        locais: {
          ...state.locais,
          fetching: 2,
          ...response
        }
      };
    case 'LIST_CATEGORIAS_PROBLEMA_SUCCESS':
        return {
          ...state,
          categorias: {
            ...state.categorias,
            fetching: 2,
            ...response
          }
        };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/modules/problema/reducer.js